import { SizeProp } from '@fortawesome/fontawesome-svg-core'
import { faThumbsUp as thumbup } from "@fortawesome/free-solid-svg-icons";
import { faThumbsUp } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from '@mui/material';
import { colors } from "../common/colors";
import SubmitButton from './SubmitButton';
import { SubmitButtonProps } from './SubmitButton';
import appServices from '../services/app-services/appServices';
import { pushUserLike } from '../services/gtm';
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { TF } from "react-translator-component";

interface Props extends Omit<SubmitButtonProps, 'validate' | 'onSubmit'> {
  iconSize: SizeProp
  liketype: "post" | "comment"
  item: any
  disabled: boolean
}

const LikeDislikeButton: React.FC<Props> = ({
  iconSize,
  liketype,
  item,
  disabled,
  ...rest
}) => {
  const { user } = useSelector((state: any) => state.userAuth);

  const [likeCount, setLikeCount] = useState<number>(0);
  const [isLike, setIsLike] = useState<boolean>(false);
  const [likeLoading, setLikeLoading] = useState<boolean>(false);

  useEffect(() => {
    setLikeCount(item?.likes_count)
    setIsLike(item?.liked_by_me)
  }, [item])

  const sendLike = async () => {
    if (disabled) return false

    setLikeLoading(true)
    try {
      if (liketype === "comment") {
        isLike ? await appServices.dislikeComment(item.id) : await appServices.likeComment(item.id);
      } else if (liketype === "post"){
        isLike ? await appServices.dislikePost(item.id) : await appServices.likePost(item.id);
      } else {
        return false
      }
      if (!isLike) {
        pushUserLike(user);
      }

      const newLikeCount = isLike ? likeCount - 1 : likeCount + 1
      setLikeCount(newLikeCount > 0 ? newLikeCount : 0)
      setIsLike(!isLike)
    } catch (error) {
      console.error(error)
    } finally {
      setLikeLoading(false)
      // 再度いいねボタンが押せなくなるため、falseを返す
      return false
    }
  };
  return (
    <>
      <SubmitButton
        isIcon={true}
        aria-label="thumbs"
        validate={async () => !likeLoading}
        onSubmit={() => sendLike()}
        disabled={disabled}
        {...rest}
      >
        {likeLoading ? (
          <CircularProgress
            style={styles.circularProgress}
            size={24}
          />
        ) : (
          <FontAwesomeIcon
            size={iconSize}
            icon={isLike ? thumbup : faThumbsUp}
            color={isLike ? colors.farm_green500 : colors.farm_gray200 }
          />
        )}
      </SubmitButton>
      {liketype === "comment" ? (
        <div style={styles.favCount}>
          {likeCount}
        </div>
      ) : (
        <span style={styles.likeText}>{TF("likes_count", likeCount)}</span>
      )}
    </>
  )
}
const styles = {
  favCount: {
    fontSize: 14,
    paddingLeft: "8px",
  },
  likeText: {
    paddingTop: 6,
    fontSize: 16
  },
  circularProgress: {
    marginTop: 10,
    marginBottom: -8,
    marginLeft: 8,
    marginRight: 8,
  },
}


export default LikeDislikeButton
